import { createSelector } from "reselect";
import get from "lodash.get";
import { createPolicyForInternalNameSelector } from "src/selectors/data_selectors";

//Constants
import { policyInternalNames } from "src/constants";

/**
 * Memoized selector to determine if alerts are enabled for dashboard
 */

export const alertsEnabledSelector = createSelector(
  createPolicyForInternalNameSelector(
    policyInternalNames.dashboardAlertsEnabled
  ),
  policy => {
    return get(policy, "attributes.policyValue", false);
  }
);
